<template>
    <div class="logistics">
        <div class="title">
            <p>店铺资金订单</p>
        </div>
        <div class="main">
            <el-card class="mb10 flex pd0" >
                <span class="mb20"> <el-input v-model="sn" style="width: 220px" placeholder="订单编号" clearable></el-input> </span>
                <span class="mb20"> <el-input v-model="shop_name" style="width: 220px" placeholder="店铺名称" clearable></el-input> </span>
                <span class="mb20"> <el-input v-model="goods_sn" style="width: 220px" placeholder="商品ID" clearable></el-input> </span>
                
                <span class="mb20">
                    <el-button @click="reset">重置</el-button>
                </span>
                <span class="mb20">
                    <el-button type="primary" @click="getList(1 )">搜索</el-button>
                </span>
            </el-card>
    <div class="tabs">
        <el-tabs v-model="tab_index"
                 @tab-click="handleClick">
          <el-tab-pane label="待支付"
                       name="1"></el-tab-pane>
          <el-tab-pane label="已支付"
                       name="2"></el-tab-pane>
        </el-tabs>
    </div>
            <el-card>
                <div class="table">
                    <div class="table pd10">
                        <el-table :data="tableData" style="width: 100%" border > 
                            <el-table-column align="center" prop="sn" label="订单编号" width="180" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="goods_name" label="商品ID" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="shop_name" label="店铺名称" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="express_companys" label="商品sku" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="amount" label="应缴金额（元）" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="create_time" label="订单生成时间" show-overflow-tooltip></el-table-column>
                            <el-table-column
                                            align="center"
                                            label="操作">
                                <template slot-scope="{ row }">
                                <div class="link">
                                    <el-link type="primary"
                                            v-show=" row.status == 1"
                                            @click="showPay(row)">去支付</el-link>

                                    <el-link type="primary"
                                            @click="Detail(row)">查看详情</el-link>
                                    
                                </div>
                                </template>
                            </el-table-column>
                            
                        </el-table>
                    </div>
                    
                    <div class="pageSize">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                        >
                        </el-pagination>
                    </div>
                    <el-dialog class="order-detail-dialog" :title="detail_title" :visible.sync="showDetailDialog"  :close-on-press-escape=false>
                        <div class="detail-title">订单信息</div>
                        <div>
                            <span>订单编号：{{detail_data.sn}}</span>
                            <span>订单生成时间：{{detail_data.create_time}}</span>
                        </div>
                        <div >
                            <span>订单类型：店铺资金</span>
                            <span>订单状态：{{detail_data.status_show}}</span>
                        </div>
                        <div>
                            <span>订单金额：{{detail_data.amount}}元</span>
                            <span>已交金额：{{detail_data.balance}}元</span>
                        </div>
                        <div>
                            <span>应缴金额：{{total_pay}}元</span>
                        </div>
                        <div  class="detail-title">店铺资金信息(本次商品保证金最高价商品)</div>
                        <div>
                            <span>商品ID：{{detail_data.goods_sn}}</span>
                            <span>商品名称：{{detail_data.goods_name}}</span>
                        </div>
                        <div>
                            <span>商品规格：{{detail_data.goods_sku}}</span>
                            <span>商品标准名称：{{detail_data.goods_standard_name}}</span>
                        </div>
                        <div>
                            <span>商品销售价：{{detail_data.goods_price}}元</span>
                            <span>保证金倍数：{{detail_data.multiple}}</span>
                        </div>
                        <div>
                            <span>保证金上限：{{detail_data.max_val}}元</span>
                            <span>保证金下限：{{detail_data.min_val}}元</span>
                        </div>
                        <div>
                            <span>商品保证金：{{detail_data.org_amount}}元</span>
                        </div>
                        <div  class="detail-title">店铺资金信息(上次商品保证金最高价商品

)</div>
                        <div>
                            <span>商品ID：{{detail_last_data.goods_sn}}</span>
                            <span>商品名称：{{detail_last_data.goods_name}}</span>
                        </div>
                        <div>
                            <span>商品规格：{{detail_last_data.goods_sku}}</span>
                            <span>商品标准名称：{{detail_last_data.goods_standard_name}}</span>
                        </div>
                        <div>
                            <span>商品销售价：{{detail_last_data.goods_price}}元</span>
                            <span>保证金倍数：{{detail_last_data.multiple}}</span>
                        </div>
                        <div>
                            <span>保证金上限：{{detail_last_data.max_val}}元</span>
                            <span>保证金下限：{{detail_last_data.min_val}}元</span>
                        </div>
                        <div>
                            <span>商品保证金：{{detail_last_data.org_amount}}元</span>
                        </div>
                    </el-dialog>
                    <!--@opened="showLoading()"-->
                    <el-dialog title="支付" :visible.sync="showPayDialog"  :close-on-press-escape=false>
                        <div>共计 :￥{{total_pay}}</div>
                        <el-form >
                        <el-form-item label="选择支付方式：">
                                <template>
                                <el-radio v-model="pay_type" label="offline" @change="changePayType()">线下支付</el-radio>
                                <el-radio v-model="pay_type" label="online" @change="changePayType()">线上支付</el-radio>
                                
                                </template>
                        </el-form-item>
                        
                        <el-card class="box-card pay-box-card" v-show=" pay_type == 'online'">
                                <template>
                                <el-radio v-model="code_type" label="WeChat" @change="changeCodeType()">微信</el-radio>
                                <el-radio v-model="code_type" label="AliPay" @change="changeCodeType()">支付宝</el-radio>
                                </template>
                                <div >请扫码支付</div>
                                <div id="pay_qrcode"></div>
                                <el-button @click="donePay(1)">已完成支付</el-button>
                        </el-card>
                        <el-card class="box-card pay-box-card" v-show=" pay_type == 'offline'">
                        
                        
                            <el-upload
                                class="avatar-uploader"
                                action="https://jsonplaceholder.typicode.com/posts/"
                                :on-success="handleUploadSuccess"
                                :show-file-list="false" 
                            >
                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                <div slot="tip" class="el-upload__tip">格式：PNG、PDF、JPG请上传支付凭证</div>
                            </el-upload>

                            <div>请在打款的时候备注【****店铺名称+保证金】</div>
                            <div>
                            汇法的开户账户信息：<br />
                            银行账号：233454255666<br />
                            银行名称：民生银行 <br />
                            支行名称：杨浦-支行民生银行<br />
                            </div>
                            <el-button @click="donePay(2)">提交</el-button>
                        </el-card>
                    </el-form>
                    </el-dialog>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "@/assets/config.json";
import QRCode from "qrcodejs2";
import { Loading } from 'element-ui';
export default {
    data() {
        return {
            myloading:{},
            tab_index:"1",
            code_type:'WeChat',
            current_sn:'',
            pay_qrcode:'',
            pay_status: 1,
            sn: "",
            goods_sn: "",
            shop_name: "",
            page: 1,
            size: 10,
            total: 0,
             tableData: [],
             showPayDialog:false,
             showDetailDialog:false,
             total_pay:0,
             pay_type:'offline',
            formLabelWidth:'120px',
            showPayDialogLoad:false,
            imageUrl: '',
            detail_shop_id:'',
            detail_title:'',
            detail_data:[],
            detail_last_data:[]
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {
        this.getList(1);
    },
    methods: {
        ...mapActions({
            getDepositList: "commodity/getDepositList",
            getDepositDetail: "commodity/getDepositDetail",
            payDepositOrder: "commodity/payDepositOrder",
            payDepositCheck: "commodity/payDepositCheck",
            payDepositOffline: "commodity/payDepositOffline",
            uploadFile: "commodity/uploadFile",
        }),
        Detail(row) {
            let params = {token: this.getToken,sn: row.sn}
            
            this.getDepositDetail(params).then((res) => {
                if (res.code == 1) {
                    this.detail_data = res.data;
                    this.detail_title = '详情  店铺ID：'+this.detail_data.shop_id+'  店铺名称：'+this.detail_data.shop_name;
                    this.total_pay = this.detail_data.amount;
                    if(this.detail_data.status == 1) {
                        this.detail_data.status_show = '待支付';
                    }else if(this.detail_data.status == 2) {
                        this.detail_data.status_show = '已支付';
                    }
                    this.detail_last_data = res.data.last_order;
                } else {
                    this.$message.error(res.msg);
                }
            });

            

            this.showDetailDialog = true;
            
        },
        getList(tag) {
            let params = {
                pay_status: this.tab_index,
                sn: this.sn,
                goods_sn: this.goods_sn,
                shop_name: this.shop_name,
                page_size: this.size,
                page: tag == 1 ? tag : this.page,
                token: this.getToken,
            };
            this.getDepositList(params).then((res) => {
                this.tableData = [];
                if (res.code == 1) {
                    if (res.data.data.length > 0) {
                        this.tableData = res.data.data;
                    }
                    this.total = res.data.count;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        rufsh() {
            window.open(`${config.brandHttps.api}/merchant/activity/orders/consignments/export?token=${this.getToken}&sn=${this.sn}&goods_sn=${this.goods_sn}&shop_name=${this.shop_name}`);
        },
        reset() {

            this.shop_name = "";
            this.goods_sn = "";
            this.sn = "";
            this.getList(1);
        },
        showLoading() {
            this.myloading = Loading.service({ fullscreen: true });
        },
        showPay(row) {
            this.total_pay = row.amount;
            this.showPayDialog = true;
            this.current_sn = row.sn;

        },
        changePayType() {
            if(this.pay_type == 'online') {
                let params = {
                    sn: this.current_sn,
                    code_type: this.code_type,
                    token: this.getToken,
                };
                this.showLoading();
                this.payDepositOrder(params).then((res) => {
                    let pay_qrcode = document.getElementById("pay_qrcode");
                    pay_qrcode.innerHTML = '';
                    if (res.code == 1) {
                        let qrcode_url = res.data;
                        new QRCode("pay_qrcode", {
                            width: 246,
                            height: 246,
                            text: qrcode_url,
                        });                    
                        this.myloading.close();
                    } else {
                        this.$message.error(res.msg);
                        this.myloading.close();
                    }
                });
            }
        },
        changeCodeType() {
            let params = {
                sn: this.current_sn,
                code_type: this.code_type,
                token: this.getToken,
            };
            this.showLoading();
            this.payDepositOrder(params).then((res) => {
                let pay_qrcode = document.getElementById("pay_qrcode");
                pay_qrcode.innerHTML = '';
                if (res.code == 1) {
                    let qrcode_url = res.data;
                    new QRCode("pay_qrcode", {
                        width: 246,
                        height: 246,
                        text: qrcode_url,
                    });                    
                    this.myloading.close();
                } else {
                    this.$message.error(res.msg);
                    this.myloading.close();
                }
            });
        },
        handleClick(tab, event) {

            this.shop_name = "";
            this.goods_sn = "";
            this.sn = "";
            if(tab.index == 1) {
                //已支付tab
                this.getList(1);
            }else {
                this.getList(1);
            }
            
        },
        donePay(type) {
            let params = {
                token: this.getToken,
                sn: this.current_sn
            };
            if(type == 1) {
                this.shop_name = "";
                this.goods_sn = "";
                this.sn = "";
                this.getList(1);
                this.showPayDialog = false;
            }else if(type == 2) {
                params.offline_file = this.imageUrl;
                this.payDepositOffline(params).then((res) => {
                    if (res.code == 1) {
                        if(res.data.result) {
                            this.shop_name = "";
                            this.goods_sn = "";
                            this.sn = "";
                            this.getList(1);
                            this.showPayDialog = false;
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        

        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },


        handleUploadSuccess(res, file) {
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            this.showLoading();
            this.uploadFile(formdata).then((response) => {
                if (response.code == 1) {
                    this.$message({
                        type: "success",
                        message: "上传成功！",
                    });
                    this.imageUrl = response.data.formdata_details[0].urls;
                    this.myloading.close();
                } else {
                    this.$message({
                        type: "warning",
                        message: response.msg,
                    });
                    this.myloading.close();
                }
            });
        }
        
    },
};
</script>

<style lang="scss" scoped>
.logistics {
    position: relative;
    height: 100%;
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;
        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;
            span {
                color: #e72f0d;
                padding: 0 5px;
            }
            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }
            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }

    .main {
        margin: 24px;
        min-width: 1200px;
        span {
            margin-right: 10px;
            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }
    }
    .pageSize {
        margin-top: 10px;
        float: right;
    }
    .table {
        min-height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
    }
}
.mb10 {
    margin-bottom: 10px;
}
.pd10 {
    padding: 10px;
}
::v-deep .el-tabs__item {
    padding: 0 42px !important;
}
::v-deep .el-tabs__active-bar {
    width: 126px !important;
    left: -43px;
}
.flex {
    ::v-deep .el-card__body {
        display: flex;
        flex-wrap: wrap;
    }
}
.mb20 {
    display: inline-block;
    margin-bottom: 20px;
}
.pd0{
    ::v-deep .el-card__body{
        padding-bottom: 0;
    }
}
.pay-box-card {
    text-align: center;
    line-height: 40px;

    
}
#pay_qrcode {
    width: 250px;
    margin-left: auto;
    margin-right: auto;
}
.link .el-link {
    padding-left: 10px;
}
</style>
<style>
.avatar-uploader .el-upload{
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
}

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

.order-detail-dialog {
    line-height: 30px;
}
.order-detail-dialog .detail-title{
     
    font-weight: bold;
    font-size: medium;
    
}
.order-detail-dialog span{
    display: inline-block;
    width: 45%;
    
}
</style>